import React from "react";
import { Group, Text } from "@mantine/core";

/** Section header (design: 11px/600 uppercase .06em) with an optional right slot. */
export function SectionLabel({
  label,
  right,
}: {
  label: string;
  right?: React.ReactNode;
}) {
  return (
    <Group justify="space-between" align="center">
      <Text
        size="11px"
        fw={600}
        tt="uppercase"
        c="dimmed"
        style={{ letterSpacing: ".06em" }}
      >
        {label}
      </Text>
      {right}
    </Group>
  );
}

export default SectionLabel;
